import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  >
    <g>
      <path
        d="M24.5 14H17.5L15.1667 17.5H12.8333L10.5 14H3.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.525 5.98833L3.5 14V21C3.5 21.6443 4.02233 22.1667 4.66667 22.1667H23.3333C23.9777 22.1667 24.5 21.6443 24.5 21V14L20.475 5.98833C20.2775 5.59093 19.8721 5.33959 19.4283 5.33333H8.57167C8.12786 5.33959 7.72249 5.59093 7.525 5.98833Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgComponent;
